import { Directive, ElementRef, NgZone, OnInit, OnDestroy, inject, output } from '@angular/core';

/**
 * Visibility Observer Directive
 *
 * Usage:
 *
 * 		<div
 * 			visibilityObserver
 * 			(visible)="onVisible($event)">
 * 		</div>
 *
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[visibilityObserver]',
  host: {
    '[class.visible]': 'isVisible'
  }
})
export class VisibilityDirective implements OnInit, OnDestroy {
  private readonly element = inject(ElementRef);
  private readonly zone = inject(NgZone);

  isVisible: boolean = false;

  readonly visible = output<unknown>();

  timeout: ReturnType<typeof setTimeout>;

  ngOnInit(): void {
    this.runCheck();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeout);
  }

  onVisibilityChange(): void {
    // trigger zone recalc for columns
    this.zone.run(() => {
      this.isVisible = true;
      this.visible.emit(true);
    });
  }

  runCheck(): void {
    const check = (): void => {
      // https://davidwalsh.name/offsetheight-visibility
      const { offsetHeight, offsetWidth }: { offsetHeight: number; offsetWidth: number } = this.element.nativeElement;

      if (offsetHeight && offsetWidth) {
        clearTimeout(this.timeout);
        this.onVisibilityChange();
      } else {
        clearTimeout(this.timeout);
        this.zone.runOutsideAngular(() => {
          this.timeout = setTimeout(() => check(), 50);
        });
      }
    };

    this.zone.runOutsideAngular(() => {
      this.timeout = setTimeout(() => check());
    });
  }
}
